export enum NumberType {
    DEGREES,
    RADIANS,
    DECIMAL,
    HMS,
    DMS
}